import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminMessages() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/admin/contact-messages").then((r) => setItems(r.data)).catch(() => {}); }, []);
    return (
        <div data-testid="admin-messages-page">
            <div className="label-tag">Contact form</div>
            <h1 className="mt-3 font-display text-4xl font-bold">Inbound messages</h1>
            <div className="mt-8 space-y-4">
                {items.length === 0 ? (
                    <div className="bg-ink-900 border border-white/10 rounded-2xl p-10 text-center text-white/50">No messages yet.</div>
                ) : items.map((m) => (
                    <div key={m.id} className="bg-ink-900 border border-white/10 rounded-2xl p-6" data-testid={`admin-message-${m.id}`}>
                        <div className="flex flex-wrap items-center justify-between gap-2">
                            <div>
                                <div className="font-display text-lg font-semibold">{m.subject}</div>
                                <div className="text-xs text-white/50 mt-1">
                                    {m.name} · {m.email}{m.phone ? ` · ${m.phone}` : ""}{m.union_name ? ` · ${m.union_name}` : ""}
                                </div>
                            </div>
                            <div className="text-xs text-white/40">{new Date(m.created_at).toLocaleString()}</div>
                        </div>
                        <p className="mt-4 text-white/80 whitespace-pre-wrap">{m.message}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
